import { AutoMap } from "@automapper/classes";
import { BaseDOM } from "./base.dom";
import { Appareil } from "./Qualif/appareil";

export class User extends BaseDOM<User> {
    @AutoMap()
    Email!: string;
    @AutoMap()
    Phone!: string;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;
    @AutoMap(() => [Appareil])
    AppareilQualifList: Appareil[] = []
}
